
import util from '../../../util'


const loadLocation = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()


    payload.context.axios.get(`api/location`, {headers}).then((response) => {
      console.log(response.data)
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar las ubicaciónes de almacén.')
        reject(error.response)
      }
      else reject(error)

    });

  })

}

const loadWarehouses = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()


    payload.context.axios.get(`api/location/warehouses`, {headers}).then((response) => {
      console.log(response.data)
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar los almacenes.')
        reject(error.response)
      }
      else reject(error)

    });

  })

}

const addChild = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()


    payload.context.axios.post(`api/location/${payload.idParent}`, payload.child, {headers}).then((response) => {
      console.log(response.data)
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al agregar el nodo hijo.')
        reject(error.response)
      }
      else reject(error)

    });

  })

}


const updateChild = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()


    payload.context.axios.put(`api/location/${payload.idChild}`, payload.child, {headers}).then((response) => {
      console.log(response.data)
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el nodo.')
        reject(error.response)
      }
      else reject(error)

    });

  })

}



const deleteNode = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()


    payload.context.axios.delete(`api/location/${payload.idNode}`, {headers}).then((response) => {
      console.log(response.data)
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {

        util.showDialogError(payload.context, `Ocurrió un error al eliminar el nodo: ${error.response.data.apierror.message}`)
        reject(error.response)
      }
      else reject(error)

    });

  })

}




const loadLocationName = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()


    payload.context.axios.get(`api/location/name/${payload.id}`, {headers}).then((response) => {
      console.log(response.data)
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar el nombre de la ubicación.')
        reject(error.response)
      }
      else reject(error)

    });

  })

}


export default {
  loadLocation,
  addChild,
  updateChild,
  deleteNode,
  loadLocationName,
  loadWarehouses
};






// WEBPACK FOOTER //
// ./src/store/modules/location/actions.js